import {
    type FC
} from "react";
import {
    View
} from "react-native";
import type IStateLayerProps from "./type";
import stylesheet, {
    useStyles
} from "./stylesheet";
import {
    NCoreUIKitTheme
} from "../../core/hooks";
import {
    useReducedMotion
} from "../../helpers/motion";

const StateLayer: FC<IStateLayerProps> = ({
    overlayColor = "default",
    isSquircle = false,
    isHovered = false,
    isPressed = false,
    borderWidth = 0,
    borderRadius,
    customTheme,
    style,
    ...props
}) => {
    const {
        shapeConfigs,
        durations,
        colors
    } = NCoreUIKitTheme.useContext(customTheme);

    const isReduceMotionEnabled = useReducedMotion();

    const {
        container: containerDynamicStyle
    } = useStyles({
        isReduceMotionEnabled,
        overlayColor,
        shapeConfigs,
        borderRadius,
        borderWidth,
        isSquircle,
        durations,
        isHovered,
        isPressed,
        colors
    });

    return <View
        {...props}
        style={[
            style,
            stylesheet.container,
            containerDynamicStyle
        ]}
        aria-hidden={true}
    />;
};
export default StateLayer;
